import { AxiosInstance } from 'axios'
import { ReturnNotify, ResponseNotify } from '@/types/internalChatAxios'
import { useNotifyStore } from '@/stores/notify'
import { RequestError } from '@/types/error'

export interface InternalChatServiceInterface {
  initialize(): Promise<ReturnNotify>;
  remove(id: number): Promise<void>
}

function notify (httpClient: AxiosInstance): InternalChatServiceInterface {
  async function initialize (): Promise<ReturnNotify> {
    const notifyStore = useNotifyStore()
    const response = await httpClient.get('/notify/initialize', notifyStore.config)

    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? null,
      errors
    }
  }

  async function remove (id: number): Promise<void> {
    const notifyStore = useNotifyStore()
    const response = await httpClient.delete<ResponseNotify>(`/notify/${id}`, notifyStore.config)
    if (response.request.status >= 400) {
        const error = JSON.parse(response.request.response)
        throw error.message
    }
  }
  return {
    initialize,
    remove
  }
}

export default notify
